module.exports = "<div id=\"chart-{{type}}\" style=\"width: 100%; height: 200px;\">\n</div>";